import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../middleware/dataSlice';

// Dynamic Receipt Types
export interface DynamicReceiptItem {
    title: string;
    content: string;
}

export interface DynamicReceiptData {
    data: DynamicReceiptItem[];
    eDate: string;
    receiptNo: string;
    isSignature: boolean;
}

export interface DynamicReceiptResponse {
    data: DynamicReceiptData;
    success: boolean;
    message: string | null;
    statusCode: number;
}

export const transactionListAPI = createApi({
    reducerPath: 'transactionListAPI',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['transactionListAPI'], // Define your tag type here
    endpoints: (builder) => ({
        getDynamicReceipt: builder.mutation<DynamicReceiptResponse, any>({
            query: (payload) => ({
                url: `/Process/GetDynamicReceipt`,
                method: 'POST',
                body: payload,
            }),
        }),
    }),
});

export const { useGetDynamicReceiptMutation } = transactionListAPI;
